import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import { H2 } from 'components/common/Text/Text'
import { HomePageCarousel } from '../CommonStyles'
import PromotionsList from '../PromotionsList'
import Promotion from '../PromotionsList/components/Promotion/Promotion'
import Link, { A } from 'components/common/Link/Link'
import { PROMOTIONS_PAGE } from 'constant'

const PromotionResultList = ({
  promotionResultList = [],
  hasStore,
  regionName,
  noPromotionsMessage,
  showStoreLocatorModal,
  carouselConfig,
  handlePromotionClick
}) =>
  <Wrapper>
    <Title>Tire Coupons, Specials &amp; Promotions</Title>
    { !hasStore ?
      <Fragment>
        <SelectStoreText>
          To see more offers for your location &nbsp;
          <A prevent handler={ showStoreLocatorModal }>
            Choose Store
          </A>
        </SelectStoreText>
        <HomePageCarousel config={ carouselConfig }>
          { promotionResultList.map((item, index) =>
            <Promotion
              key={ index }
              promotionData={{ ...item }}
              onClick={ () => handlePromotionClick({ item, index }) } />)
          }
        </HomePageCarousel>
      </Fragment> :
      <PromotionsList
        regionName={ regionName }
        homePageVersion
        carouselConfig={ carouselConfig }
        promotionResultList={ promotionResultList }
        noPromotionsMessage={ noPromotionsMessage } />
    }
    <PromoPageLink to={ PROMOTIONS_PAGE }>View All Specials</PromoPageLink>
  </Wrapper>

PromotionResultList.propTypes = {
  carouselConfig: PropTypes.shape(),
  handlePromotionClick: PropTypes.func,
  hasStore: PropTypes.bool,
  noPromotionsMessage: PropTypes.string,
  promotionResultList: PropTypes.arrayOf(PropTypes.shape()),
  regionName: PropTypes.string,
  showStoreLocatorModal: PropTypes.func
}

export default PromotionResultList

const Wrapper = styled.div`
  margin: 50px 0;
`

const Title = styled(H2)`
  position: relative;
  text-align: center;
  text-transform: uppercase;
  ${Mixin.font.GothamBold(24)}
  ${Mixin.responsive('margin', '0 8px 14px 8px', '0 8px 10px 8px')}
  ${Mixin.responsive('padding-bottom', '10px', '15px')}
  transform: scale(1, 1.5);
`

const SelectStoreText = styled.span`
  display: block;
  text-align: center;
  padding: 10px;
  ${Mixin.font.GothamBook(14)}
`

const PromoPageLink = styled(Link)`
  display: block;
  text-align: center;
  ${Mixin.font.GothamBook(14)}
`
